import { useState } from 'react';
import { Box, IconButton, Grid } from '@mui/material';
import { Button, List, TextField } from 'app/shared';
import { usePatientList } from 'app/hooks';
import { IPatientSchema } from 'generated/axios';
import { Typography } from '../typography';
import { t } from 'i18next';
import { formatDate } from 'app/utils';

import ClearIcon from '@mui/icons-material/Clear';
import RefreshIcon from '@mui/icons-material/Refresh';

interface Props {
  onConfirmPatient: (company: IPatientSchema) => void;
  onCancel: () => void;
}

export const SearchPatient = ({ onConfirmPatient, onCancel }: Props) => {
  const { list, count, page, pageSize, handlePageChange, handleFilter, handlePageSizeChange, refresh, loading } =
    usePatientList();

  const [search, setSearch] = useState<string>();

  const handleSearch = (newSearch?: string) => {
    setSearch(newSearch);
  };

  return (
    <>
      <Box bgcolor={'primary.main'} padding={2} display={'flex'} justifyContent={'space-between'} alignItems={'center'}>
        <Box display={'inherit'} alignItems={'inherit'}>
          <Typography color={'common.white'} variant="h6">
            {t('patient.select')}
          </Typography>
          <IconButton onClick={refresh}>
            <RefreshIcon sx={{ color: 'common.white' }} />
          </IconButton>
        </Box>

        <IconButton onClick={onCancel}>
          <ClearIcon sx={{ color: 'common.white' }} />
        </IconButton>
      </Box>
      <Grid container spacing={2} paddingBottom={2} display={'flex'} alignItems={'center'} padding={2}>
        <Grid size={4}>
          <TextField
            value={search}
            size="small"
            onChange={(e) => handleSearch(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter') {
                handleFilter(search);
                e.preventDefault();
              }
            }}
          />
        </Grid>
        <Grid size={4}>
          <Button
            onClick={() => {
              handleFilter(search);
            }}
          >
            {t('actions.search')}
          </Button>
        </Grid>
      </Grid>
      <List
        list={list}
        page={page}
        pageSize={pageSize}
        loading={loading}
        onPageChange={handlePageChange}
        onPageSizeChange={handlePageSizeChange}
        count={count}
        keyGetter={(el) => el.id}
        onItemClick={onConfirmPatient}
        fields={[
          {
            title: t('patient.lastName'),
            key: 'last_name',
          },
          {
            title: t('patient.firstName'),
            key: 'first_name',
          },
          {
            key: 'birth_date',
            title: t('patient.birthDate'),
            valueGetter: (patient) => formatDate(patient.birth_date),
          },
          {
            key: 'company',
            title: t('patient.company'),
            path: ['name'],
          },
        ]}
      />
    </>
  );
};
